import BaseComponent from 'scripts/BaseComponent.js';
import { AccessibilityHelper } from 'scripts/accessibility/accessibilityHelper';

export default class AccountLoginRegister extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      mainToggle: '.js-main-toggle',
      toggle: '.js-toggle',
      form: '.js-form',
      body: 'body',
    };

    this.dom = {
      $component: component,
      $mainToggles: this.$getAll(this.refs.mainToggle),
      $toggles: this.$getAll(this.refs.toggle),
      $forms: this.$getAll(this.refs.form),
      $body: document.querySelector(this.refs.body),
    };

    this.state = {
      formActiveClass: 'is-active',
      toggleAccountDrawerFormEvent: 'toggleaccountdrawerform',
      accessibilityHelper: new AccessibilityHelper(),
    };

    this.mount();

    this.init();
  }

  mount() {
    super.mount();
    const { dom } = this;
    this.setClickWithElement(dom.$toggles, this.toggleClickHandler);
  }

  toggleClickHandler($el) {
    const formToToggle = $el.dataset.toggles;
    this.toggleForm(formToToggle);
  }

  init() {
    const { dom } = this;
    if (dom.$body.classList.contains('template-login')) {
      this.toggleForm('login');
    } else if (dom.$body.classList.contains('template-register')) {
      this.toggleForm('register');
    } else {
      this.toggleForm('login');
    }
  }

  toggleForm(formName) {
    console.log('toggleForm', formName);
    const { dom, state } = this;
    const $formToShow = dom.$forms.find(($el) => $el.dataset.form === formName);
    const $mainToggleToShow = dom.$mainToggles.find(($el) => $el.dataset.toggles === formName);
    dom.$forms.forEach(($form) => this.hideForm($form));
    this.showForm($formToShow);
    if ($mainToggleToShow) {
      dom.$mainToggles.forEach(($el) => $el.classList.remove(state.formActiveClass));
      $mainToggleToShow.classList.add(state.formActiveClass);
    }
  }

  hideForm($form) {
    const { state } = this;
    $form.classList.remove(state.formActiveClass);
    $form.setAttribute('aria-hidden', 'true');
    $form.setAttribute('aria-expanded', 'false');
    state.accessibilityHelper.updateElementAccessibility($form, false);
  }

  showForm($form) {
    const { state } = this;
    $form.classList.add(state.formActiveClass);
    $form.setAttribute('aria-hidden', 'false');
    $form.setAttribute('aria-expanded', 'true');
    state.accessibilityHelper.updateElementAccessibility($form, true);
    this.dispatch(state.toggleAccountDrawerFormEvent);
  }
}
